module.exports = " <div class=modal-header> <h3 class=modal-title>{{title}}</h3> <div class=\"modal-cancel close\" ng-click=cancel()><i class=\"icon iconfont icon-shanchu3\"></i></div> </div> <div class=modal-body> <div ng-if=result ng-repeat=\"text in result track by $index\">{{text}}</div> <div ng-if=!result>{{resultText}}</div> </div> <div class=modal-footer> <button class=\"btn btn-default btn-md\" type=button ng-click=ok()>确定</button> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/input/inputInvoice/collection/view/importmodal.html
// module id = 2Iay
// module chunks = 0